"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const apollo_link_context_1 = require("apollo-link-context");
const resetToken_1 = __importDefault(require("./resetToken"));
exports.default = _ref => {
  let getToken = _ref.getToken,
    expired = _ref.expired,
    reauthenticate = _ref.reauthenticate,
    format = _ref.format,
    tokenInvalid = _ref.tokenInvalid;
  return (0, apollo_link_context_1.setContext)((_request, previousContext) => __awaiter(void 0, void 0, void 0, function* () {
    const _previousContext$requ = previousContext.requireAuth,
      requireAuth = _previousContext$requ === void 0 ? true : _previousContext$requ,
      headers = previousContext.headers;
    if (!requireAuth) {
      return previousContext;
    }
    const token = getToken();
    const isTokenExpired = token ? expired(token) : true;
    const nextToken = isTokenExpired ? yield reauthenticate() : token;
    if (nextToken) {
      return {
        headers: Object.assign(Object.assign({}, headers), {
          authorization: format(nextToken)
        })
      };
    }
    console.warn("Authentication link was unable to get a new token!");
    return null;
  })).concat((0, resetToken_1.default)({
    tokenInvalid
  }));
};